import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  Alert,
  Button,
} from '@mui/material'
import PageHelpButton from '../../components/PageHelpButton'
import { usePortalData } from '../../components/portal/PortalDataProvider'
import AttachmentsTab from '../../components/client-detail/AttachmentsTab'
import type { PortalSectionProps } from '../../components/portal/portalSection'

export default function PortalDocuments({ embedded }: PortalSectionProps = {}) {
  // leadId is the pre-conversion half of this client's files, and it only
  // exists on the dashboard record.
  const { clientId, leadId, dashboard, refresh } = usePortalData()

  return (
    <Box>
      {/* Suppressed when this renders as a tab of My Profile, which supplies
          the page heading. */}
      {!embedded && (
        <>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Typography variant="h4" component="h1">
          My Documents
        </Typography>
        <PageHelpButton articleId="page-portal-documents" />
      </Stack>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Upload and manage documents for your search.
      </Typography>
        </>
      )}

      {/* Without the dashboard there is no leadId, so anything filed before
          this client was converted from a lead is missing from the list below
          — and missing silently, which is worse than the list being short.
          Non-fatal: the client-era files are still theirs to see. */}
      {dashboard === null && (
        <Alert
          severity="warning"
          sx={{ mb: 2 }}
          action={
            <Button color="inherit" size="small" onClick={() => refresh()}>
              Retry
            </Button>
          }
        >
          Some of your older documents could not be loaded. Anything added since you became a client is still listed below.
        </Alert>
      )}

      <Card>
        <CardContent>
          <AttachmentsTab
            entityId={clientId}
            entityType="client"
            fallbackEntityId={leadId}
            fallbackEntityType="lead"
          />
        </CardContent>
      </Card>
    </Box>
  )
}
